<div class="relative">
  <p
    class="font-default rounded-sm border-2 px-3 py-2 text-xl xl:px-5 xl:py-3 xl:text-3xl"
    [class]="{
      'bg-orange-100': line().speaker === 'LEFT',
      'bg-blue-100': line().speaker === 'RIGHT',
      'border-orange-500': line().speaker === 'LEFT',
      'border-blue-500': line().speaker === 'RIGHT',
    }"
  >
    {{ line().content }}
  </p>

  @if (line().speaker === 'RIGHT') {
    <rid-dialog-line-indicator
      class="absolute top-[50%] left-full translate-x-4 -translate-y-[50%]"
      [speaker]="line().speaker"
      animate.enter="anim-slide-from-left"
      [style.animation-delay.ms]="250 + index() * 100"
    />
  } @else {
    <rid-dialog-line-indicator
      class="absolute top-[50%] right-full -translate-x-4 -translate-y-[50%]"
      [speaker]="line().speaker"
      animate.enter="anim-slide-from-right"
      [style.animation-delay.ms]="250 + index() * 100"
    />
  }
</div>
